export const getCharCode = (value: string): string => {
	let result = ''
	if (value) {
		for (let i = 0; i < value.length; i++) {
			result += value.charCodeAt(i)
		}
	}
	return result
}